<template>
  <v-container>
    <h1 class="display-1 pt-3">Responses by Course</h1>
    <v-breadcrumbs :items="items" class="pa-0 ma-0 mb-2 mt-2"></v-breadcrumbs>
    <a-l-courses class="mt-2" />
  </v-container>
</template>
<script>
import courses from "./components/allcourses";
export default {
  components: {
    "a-l-courses": courses
  },
  computed: {
    items() {
      return [
        {
          text: "Courses",
          disabled: false,
          to: { name: "responses" },
          link: false,
          exact: true
        }
      ];
    }
  }
};
</script>
